export enum TypeUser {
  PARTICULIER = "PARTICULIER",
  ENTREPRISE = "ENTREPRISE",
  ADMINISTRATEUR = "ADMINISTRATEUR",
  VETERINAIRE = "VETERINAIRE",
  TECHNIQUE = "TECHNIQUE",
  TERRAIN = "TERRAIN",
  OFFICIER="OFFICIER",
  FOURNISSEUR="FOURNISSEUR",
  SANITAIRE="SANITAIRE",
  AUTRE = "AUTRE"
}

export interface Adresse {
  pays: string;
  cp: string;
  ville: string;
  intituleRue: string;
  numeroRue: number | null;
}

export interface UtilisateurDto {
  nom: string;
  prenom: string;
  phone: string;
  email: string;
  dateCreation: string;
  derniereConnexion: string;
  dateNaissance: string;
  dateMiseAJour: string;
  adresse: Adresse;
  matricule: string;
  villeNaissance: string;
  villeActivite: string;
  type: TypeUser | string;
  disabled: boolean;
}

export const defaultUtilisateur: UtilisateurDto = {
  nom: "",
  prenom: "",
  phone: "",
  email: "",
  dateCreation: "",
  derniereConnexion: "",
  dateNaissance: "",
  dateMiseAJour: "",
  adresse: { pays: "Sénégal", cp: "115", ville: "", intituleRue: "", numeroRue: 0 },
  matricule: "",
  villeNaissance: "",
  villeActivite: "",
  type: TypeUser.PARTICULIER,
  disabled: false,
};